import { Link } from 'react-router-dom';
import mediaUrl from '../../service/mediaUrl';
import { excerpt } from '../../utils/text';
import { formatPublicationTime } from './functions';
import { getCalendarPillStyle } from './pillStyles';
import { CalendarGranularity, CalendarPublication } from './types';
import nfThumb from '../../assets/nf_thumb.svg';

type InlinePublicationCardProps = Readonly<{
    publication: CalendarPublication;
    index: number;
    variant: CalendarGranularity;
}>;

const CARD_CLASS = 'flex gap-1 rounded-sm p-1';

const THUMBNAIL_CLASS: Record<CalendarGranularity, string> = {
    [CalendarGranularity.Month]: 'rounded-md h-[100px] object-cover w-1/2',
    [CalendarGranularity.Week]: 'rounded-md h-[110px] object-cover w-1/2',
    [CalendarGranularity.Day]: 'rounded-md h-[140px] object-cover',
};

const TITLE_ROW_CLASS = 'flex-1 text-[11px] font-medium leading-snug';
const TITLE_MAX_LENGTH_BY_VARIANT: Record<CalendarGranularity, number> = {
    [CalendarGranularity.Month]: 25,
    [CalendarGranularity.Week]: 25,
    [CalendarGranularity.Day]: 300,
};

function getTitleDisplay(
    variant: CalendarGranularity,
): Readonly<{ titleClassName: string; maxLength: number }> {
    return {
        titleClassName: `${TITLE_ROW_CLASS}`,
        maxLength: TITLE_MAX_LENGTH_BY_VARIANT[variant],
    };
}
const VIEW_LINK_CLASS =
    'flex justify-center rounded-full border border-solid border-primary bg-primary py-0.5 px-2 text-[11px] font-medium text-dark-gray';

export function InlinePublicationCard({ publication, index, variant }: InlinePublicationCardProps) {
    const { titleClassName, maxLength: titleMaxLength } = getTitleDisplay(variant);
    const title = excerpt(publication.title, titleMaxLength);

    return (
        <article className={`${CARD_CLASS} ${getCalendarPillStyle(index)}`}>
            <img
                src={mediaUrl(publication)}
                alt={publication.title}
                className={`${THUMBNAIL_CLASS[variant]}`}
            />
            <div className="flex w-full min-w-0">
                <div className="flex flex-col flex-1 min-w-0">
                    <div className={titleClassName}>
                        <div className="flex justify-between w-full">
                            <span className="opacity-80">
                                {formatPublicationTime(publication.publicationDate)}
                            </span>
                            {publication.isGlobal ? (
                                <img src={nfThumb} alt="Global" className="h-3 w-3" />
                            ) : null}
                        </div>
                        <p className="break-words">{title}</p>
                    </div>
                    <div className="flex shrink-0 justify-center">
                        <Link
                            to={`/show_publication/${publication.id}`}
                            className={VIEW_LINK_CLASS}
                        >
                            Voir
                        </Link>
                    </div>
                </div>
            </div>
        </article>
    );
}
